import { LogoutDtoImpl } from '../../../core/dto/logout/logoutdto';
import { LogoutResponse } from '../../../core/api/myaccount/logout/logoutresponse';
import { LogoutRequestImpl } from '../../../core/api/myaccount/logout/logoutrequest';
import { CategoryDto, CategoryDtoImpl } from '../../../core/dto/categories/categorydto';
import { CategoriesResponse } from '../../../core/api/categories/categoriesresponse';
import { CategoriesRequestImpl } from '../../../core/api/categories/categoriesrequest';
import { ToolbarAPIModel, ToolbarAPIModelImpl } from '../toolbar/toolbarapimodel';
import { PackStatusDtoImpl } from '../../../core/dto/packstatus/packstatusdto';
import { PackStatusResponse } from '../../../core/api/packstatus/packstatusresponse';
import { PackStatusRequestImpl } from '../../../core/api/packstatus/packstatusrequest';

export interface ToolbarSearchAPIModel extends ToolbarAPIModel
{
    logout(): void;
    getPackStatusAPI(): void; 
}

export class ToolbarSearchAPIModelImpl extends ToolbarAPIModelImpl implements ToolbarSearchAPIModel
{
  getPackStatusAPI(): void 
  { 
          console.log("packStatusAPI() invoked");
          let packStatusDto = new PackStatusDtoImpl();
          packStatusDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
 
          this.getContext().getAPIProcessorFactory().getMyAccountProcessorFactory().getPackStatus()
          .success((packStatusResponse: PackStatusResponse)=>
          {
            console.log("-------------toolbar"+packStatusResponse.getPackStatusDto().getPackName());
            packStatusDto.setPackName(packStatusResponse.getPackStatusDto().getPackName());
            this.getContext().getUserContext().setPackName(packStatusResponse.getPackStatusDto().getPackName());
            
            let packNames = this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("PACKNAME");
    
            packNames.split("|").forEach((packName: string) =>
            {
                let packs = packName.split(",");
                if(packs[0] === packStatusResponse.getPackStatusDto().getPackName())
                {   
                    this.getContext().getUserContext().setPackDisplayName(packs[1]);
                }
            });
    
            this.getContext().setUserContext(this.getContext().getUserContext());
            
           })
          .failure((packStatusResponse: PackStatusResponse)=>
           {
            
           })
          .execute(new PackStatusRequestImpl(packStatusDto));
  } 

     logout(): void 
     { 
             let logoutDto = new LogoutDtoImpl();
             logoutDto.setRefreshToken(this.getContext().getUserContext().getRefreshToken());
    
             this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
             .getLogoutDetails()
             .success((logoutResponse: LogoutResponse)=>
             {
                 this.getAPIModelHandler().onSuccess(logoutResponse.getAPIFeature(), 
                 logoutResponse.getDescription(), logoutResponse.getAPIFeature());
               
              })
             .failure((logoutResponse: LogoutResponse)=>
              {
                this.getAPIModelHandler().onFailure(logoutResponse.getAPIFeature(), 
                logoutResponse.getDescription(), undefined);
              })
             .execute(new LogoutRequestImpl(logoutDto));
     } 

     getCategories(): void 
     {
        //  this.getAPIModelHandler().onSuccess(APIFeatures.SIGNUP_CATEGORIES, 
        //  "", this.getCategoriesData());
        //  this.getAPIProcesssorFactory().getSignupCategoriesDetails()
        //  .success((signUpCategoriesResponse : SignupCategoriesResponse)=>
        //  {
        //      this.getAPIModelHandler().onSuccess(signUpCategoriesResponse.getAPIFeature(), 
        //      signUpCategoriesResponse.getDescription(), signUpCategoriesResponse.getSignupCategoriesDtos());
        //  })
        //  .failure((signUpCategoriesResponse : SignupCategoriesResponse)=>
        //  {
        //      this.getAPIModelHandler().onFailure(signUpCategoriesResponse.getAPIFeature(), 
        //      signUpCategoriesResponse.getDescription(), {});
        //  })
        //  .execute(new SignupCategoriesRequestImpl(new CategoryDtoImpl()));

         let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(categoriesResponse.getAPIFeature(), 
                        categoriesResponse.getDescription(), categoriesResponse.getCategoriesList()); 
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(categoriesResponse.getAPIFeature(), 
                      categoriesResponse.getDescription(), categoriesResponse);
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));
     }

     getCategoriesData(): CategoryDto[]
    {
        let list: CategoryDto[] = [];

        let categorydto1 = new CategoryDtoImpl();
        categorydto1.setId("561");
        categorydto1.setTitle("ISLAMIC");
        categorydto1.setImgPath("https://callertunes.etisalat.ae/en/islamic_small1519051932981.jpg");

        let categorydto2 = new CategoryDtoImpl();
        categorydto2.setId("515");
        categorydto2.setTitle("ENGLISH");
        categorydto2.setImgPath("https://callertunes.etisalat.ae/en/english_small1519049946025.jpg");

        let categorydto3 = new CategoryDtoImpl();
        categorydto3.setId("433");
        categorydto3.setTitle("BURMESE");
        categorydto3.setImgPath("https://callertunes.etisalat.ae/en/arabic_small1519049116830.jpg");

        let categorydto4 = new CategoryDtoImpl();
        categorydto4.setId("541");
        categorydto4.setTitle("INTERNATIONAL");
        categorydto4.setImgPath("https://callertunes.etisalat.ae/en/international_small1519051024200.jpg");

        let categorydto7 = new CategoryDtoImpl();
        categorydto7.setId("479");
        categorydto7.setTitle("SOUTHASIAN");
        categorydto7.setImgPath("https://callertunes.etisalat.ae/en/southasian_small1519053949221.jpg");


        list.push(categorydto1);
        list.push(categorydto2);
        list.push(categorydto3);
        list.push(categorydto4);
        list.push(categorydto7);
       

        return list;
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/toolbarsearchapimodel.tsx